<template>
    <div class="designerpage">

        <shepley-designer-question-door-range v-if="range_panel_required"
                                              :fabricator="fabricator"
                                              v-model:target="door.attr.door_range"
                                              :ranges="ranges"
                                              title="Choose a Door Range"
                                              :defaults="defaults()"
                                              :reference_on="reference_on"></shepley-designer-question-door-range>

        <div>
            <wb-designer-question-select-door :fabricator="fabricator"
                                              :secured-by-design="door.attr.secured_by_design"
                                              :door-range="door.attr.door_range"
                                              v-model:target="door.attr.slab"></wb-designer-question-select-door>

            <designer-question-frame-material :slab="door.attr.slab"
                                                 :fabricator="fabricator"
                                                 v-model:target="door.attr.frame_material"></designer-question-frame-material>
        </div>

        <div class="designeroption">
            <designer-question-hinge-side :fabricator="fabricator"
                                          v-model:target="door.attr.hinge_side"></designer-question-hinge-side>

            <designer-question-opening-direction :fabricator="fabricator"
                                                 v-model:target="door.attr.opening_direction"></designer-question-opening-direction>
        </div>

        <shepley-designer-question-select-frame-style :fabricator="fabricator"
                                                      :is-firedoor="is_firedoorrange"
                                                      v-model:target="door.attr.frame_style"></shepley-designer-question-select-frame-style>

        <div class="designeroption" data-designer-component-id="door_colour">
            <h3>Choose Your Door Colour</h3>

            <div class="colourtabs">
                <ul>
                    <li><a href="#dc-tabs-1">External Colour</a></li>
                    <li><a href="#dc-tabs-2">Internal Colour</a></li>
                </ul>
                <div id="dc-tabs-1">
                    <wb-designer-question-door-colour-external :fabricator="fabricator" :slab="door.attr.slab"
                                                               v-model:target="door.attr.external_colour"></wb-designer-question-door-colour-external>
                </div>
                <div id="dc-tabs-2">
                    <wb-designer-question-door-colour-internal :fabricator="fabricator" :slab="door.attr.slab"
                                                               :external-colour="door.attr.external_colour"
                                                               v-model:target="door.attr.door_colour_internal"></wb-designer-question-door-colour-internal>
                </div>
            </div>
        </div>

        <div class="designeroption" data-designer-component-id="frame_colour">
            <h3>Pick Your Frame Colour</h3>

            <div class="colourtabs">
                <ul>
                    <li><a href="#tabs-1">External Colour</a></li>
                    <li><a href="#tabs-2">Internal Colour</a></li>
                </ul>
                <div id="tabs-1">
                    <wb-designer-question-frame-colour-external :fabricator="fabricator"
                                                                :frame-material="door.attr.frame_material"
                                                                :slab="door.attr.slab"
                                                                :profile="door.attr.profile"
                                                                v-model:target="door.attr.frame_colour_external"></wb-designer-question-frame-colour-external>
                </div>
                <div id="tabs-2">
                    <wb-designer-question-frame-colour-internal :fabricator="fabricator"
                                                                :frame-colour-external="door.attr.frame_colour_external"
                                                                :slab="door.attr.slab"
                                                                :profile="door.attr.profile"
                                                                v-model:target="door.attr.frame_colour_internal"></wb-designer-question-frame-colour-internal>
                </div>
            </div>
        </div>

        <div>
            <shepley-designer-question-secured-by-design v-if="!is_firedoorrange && !is_stablerange && door.attr.door_range !== 62" :fabricator="fabricator"
                                                    v-model:target="door.attr.secured_by_design"
                                                    :slab="door.attr.slab"></shepley-designer-question-secured-by-design>

            <wb-designer-question-door-glass-laminated :fabricator="fabricator"
                                                       title="Laminated Glass:"
                                                       :slab="door.attr.slab"
                                                       :frame-style="door.attr.frame_style"
                                                       :side-panels="door.attr.side_panels"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       :is-firedoor="is_firedoorrange"
                                                       v-model:target="door.attr.laminated_glass"></wb-designer-question-door-glass-laminated>
        </div>

        <div>
            <wb-designer-question-glass-design :fabricator="fabricator"
                                               v-model:target="door.attr.glass_design"
                                               :laminated-glass="door.attr.laminated_glass"
                                               :door-range="door.attr.door_range"
                                               :slab="door.attr.slab"></wb-designer-question-glass-design>

            <designer-question-glass-text v-model:target="door.attr.glass_text"
                                          :glass-design="door.attr.glass_design"></designer-question-glass-text>
        </div>

        <wb-designer-question-glass-backing-design :fabricator="fabricator"
                                                   v-model:target="door.attr.glass_backing_design"
                                                   :slab="door.attr.slab"
                                                   :glass-design="door.attr.glass_design"></wb-designer-question-glass-backing-design>

        <shepley-designer-question-select-frame-sidepanels :fabricator="fabricator"
                                                           v-model:target="door.attr.side_panels"
                                                           :door-range="door.attr.door_range"
                                                           :frame-style="door.attr.frame_style"
                                                           :frame-profile="door.attr.profile"
                                                           :frame-material="door.attr.frame_material"
                                                           :laminated-glass="door.attr.laminated_glass"
                                                           :frame-colour-internal="door.attr.frame_colour_internal"
                                                           :frame-colour-external="door.attr.frame_colour_external"
                                                           :secured-by-design="door.attr.secured_by_design"
                                                           :measurements.sync="door.attr.measurements"
                                                           :slab="door.attr.slab"
                                                           :mdd="mdd"
        ></shepley-designer-question-select-frame-sidepanels>

        <div v-if="!is_stablerange">
            <shepley-designer-question-hardware-suite-selector :fabricator="fabricator"
                                                               v-model:target="door.attr.suite"
                                                               :slab="door.attr.slab"
                                                               :secured-by-design="door.attr.secured_by_design"
                                                               :opening-direction="door.attr.opening_direction"
                                                               :door-range="door.attr.door_range"
                                                               :profile="door.attr.profile"></shepley-designer-question-hardware-suite-selector>
        </div>

        <div>
            <wb-designer-question-hardware-colour v-if="is_stablerange" :fabricator="fabricator"
                                                             v-model:target="door.attr.hardware_colour"
                                                             :sbd="door.attr.secured_by_design"
                                                             :slab="door.attr.slab"
                                                             :door-range="door.attr.door_range"
                                                             :profile="door.attr.profile"
                                                             :opening-direction="door.attr.opening_direction"></wb-designer-question-hardware-colour>
            <wb-designer-question-hardware-colour-with-suite v-if="!is_stablerange" :fabricator="fabricator"
                                                             v-model:target="door.attr.hardware_colour"
                                                             :sbd="door.attr.secured_by_design"
                                                             :slab="door.attr.slab"
                                                             :hardware-suite="door.attr.suite"
                                                             :door-range="door.attr.door_range"
                                                             :profile="door.attr.profile"
                                                             :opening-direction="door.attr.opening_direction"></wb-designer-question-hardware-colour-with-suite>
        </div>
        <div>
            <wb-designer-question-hardware-handle-with-suite v-if="!is_firedoorrange && !is_stablerange" :fabricator="fabricator"
                                                             v-model:target="door.attr.hardware_handle"
                                                             :slab="door.attr.slab"
                                                             :secured-by-design="door.attr.secured_by_design"
                                                             :opening-direction="door.attr.opening_direction"
                                                             :hardware-colour="door.attr.hardware_colour"
                                                             :hardware-suite="door.attr.suite"
                                                             :door-range="door.attr.door_range"
                                                             :profile="door.attr.profile"></wb-designer-question-hardware-handle-with-suite>
            <wb-designer-question-hardware-handle v-if="is_firedoorrange || is_stablerange" :fabricator="fabricator"
                                                  v-model:target="door.attr.hardware_handle"
                                                  :slab="door.attr.slab"
                                                  :secured-by-design="door.attr.secured_by_design"
                                                  :opening-direction="door.attr.opening_direction"
                                                  :hardware-colour="door.attr.hardware_colour"
                                                  :hardware-suite="door.attr.suite"
                                                  :door-range="door.attr.door_range"
                                                  :profile="door.attr.profile"></wb-designer-question-hardware-handle>

            <synseal-designer-question-hardware-decorative-handle v-show="false" :fabricator="fabricator"
                                                                  v-model:target="door.attr.hardware_decorative_handle"
                                                                  :slab="door.attr.slab"
                                                                  :hardware-colour="door.attr.hardware_colour"
                                                                  :door-range="door.attr.door_range"></synseal-designer-question-hardware-decorative-handle>
            <synseal-designer-question-hardware-decorative-handle-position v-show="false" :fabricator="fabricator"
                                                                           v-model:target="door.attr.hardware_decorative_handle_pos"
                                                                           :slab="door.attr.slab"
                                                                           :frame-material="door.attr.frame_material"
                                                                           :hardware-decorative-handle="door.attr.hardware_decorative_handle"></synseal-designer-question-hardware-decorative-handle-position>
        </div>

        <div>
            <wb-designer-question-hardware-escutcheon :fabricator="fabricator"
                                                      v-model:target="door.attr.hardware_escutcheon"
                                                      :slab="door.attr.slab"
                                                      :secured-by-design="door.attr.secured_by_design"
                                                      :hardware-colour="door.attr.hardware_colour"
                                                      :hardware-handle="door.attr.hardware_handle"
                                                      :door-range="door.attr.door_range"
                                                      :profile="door.attr.profile"></wb-designer-question-hardware-escutcheon>

            <designer-question-hardware-escutcheon-position :fabricator="fabricator"
                                                            v-model:target="door.attr.hardware_escutcheon_pos"
                                                            :slab="door.attr.slab"
                                                            :frame-material="door.attr.frame_material"
                                                            :hardware-escutcheon="door.attr.hardware_escutcheon"></designer-question-hardware-escutcheon-position>
        </div>
        <div v-show="1===2 && is_stablerange">
            <wb-designer-question-hardware-escutcheon-stable :fabricator="fabricator"
                                                             title="Stable Bottom Leaf Escutcheon"
                                                             v-model:target="door.attr.hardware_escutcheon_stable"
                                                             :slab="door.attr.slab"
                                                             :secured-by-design="door.attr.secured_by_design"
                                                             :hardware-colour="door.attr.hardware_colour"
                                                             :hardware-handle="door.attr.hardware_handle"
                                                             :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                             :door-range="door.attr.door_range"></wb-designer-question-hardware-escutcheon-stable>

            <designer-question-hardware-escutcheon-stable-position :fabricator="fabricator"
                                                                   v-model:target="door.attr.hardware_escutcheon_stable_pos"
                                                                   :slab="door.attr.slab"
                                                                   :frame-material="door.attr.frame_material"
                                                                   :hardware-escutcheon="door.attr.hardware_escutcheon_stable"></designer-question-hardware-escutcheon-stable-position>
        </div>
        <div>
            <designer-question-hardware-lock v-show="1 === 2" :fabricator="fabricator"
                                             v-model:target="door.attr.hardware_lock"
                                             :secured-by-design="door.attr.secured_by_design"
                                             :hinge-side="door.attr.hinge_side"
                                             :slab="door.attr.slab"
                                             :frame-material="door.attr.frame_material"
                                             :hardware-handle="door.attr.hardware_handle"
                                             :opening_direction="door.attr.opening_direction"
                                             :hardware-escutcheon="door.attr.hardware_escutcheon"
                                             :door-range="door.attr.door_range"></designer-question-hardware-lock>

            <div v-show="technical_should_show && !is_firedoorrange">
            <designer-question-hardware-rim-lock :fabricator="fabricator"
                                                      v-model:target="door.attr.hardware_rim_lock"
                                                      :slab="door.attr.slab"
                                                      :secured-by-design="door.attr.secured_by_design"
                                                      :hardware-colour="door.attr.hardware_colour"
                                                      :hardware-handle="door.attr.hardware_handle"
                                                    :door-range="door.attr.door_range"></designer-question-hardware-rim-lock>

                <designer-question-hardware-rim-lock-position :fabricator="fabricator"
                                                              v-model:target="door.attr.hardware_rim_lock_pos"
                                                              :slab="door.attr.slab"
                                                              :frame-material="door.attr.frame_material"
                                                              :hardware-rim-lock="door.attr.hardware_rim_lock"></designer-question-hardware-rim-lock-position>
            </div>

            <designer-question-hardware-cylinder v-show="technical_should_show" :fabricator="fabricator"
                                                    title="Choose Your Cylinder"
                                                    :slab="door.attr.slab"
                                                    v-model:target="door.attr.hardware_cylinder"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :hardware-lock="door.attr.hardware_lock"
                                                    :hardware-colour="door.attr.hardware_colour"
                                                    :opening_direction="door.attr.opening_direction"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :door-range="door.attr.door_range"></designer-question-hardware-cylinder>

            <designer-question-hardware-cylinder-stable v-show="is_stablerange" :fabricator="fabricator"
                                                           title="Stable Bottom Leaf Cylinder"
                                                           v-model:target="door.attr.hardware_cylinder_stable"
                                                           :slab="door.attr.slab"
                                                           :secured-by-design="door.attr.secured_by_design"
                                                           :hardware-lock="door.attr.hardware_lock"
                                                           :hardware-colour="door.attr.hardware_colour"
                                                           :hardware-handle="door.attr.hardware_handle"
                                                           :hardware-cylinder="door.attr.hardware_cylinder"
                                                           :door-range="door.attr.door_range"></designer-question-hardware-cylinder-stable>

            <designer-question-hardware-cylinder-guard v-show="technical_should_show" :fabricator="fabricator"
                                                       v-model:target="door.attr.hardware_cylinder_guard"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       :hardware-cylinder="door.attr.hardware_cylinder"
                                                       :hardware-colour="door.attr.hardware_colour"></designer-question-hardware-cylinder-guard>
        </div>

        <div class="designeroption">
            <wb-designer-question-hardware-letterbox :fabricator="fabricator"
                                                     v-model:target="door.attr.hardware_letterbox"
                                                     :slab="door.attr.slab"
                                                     :side-panels="door.attr.side_panels"
                                                     :frame-id="door.attr.frame_style.frame_id"
                                                     :hardware-handle="door.attr.hardware_handle"
                                                     :hardware-colour="door.attr.hardware_colour"
                                                     :secured-by-design="door.attr.secured_by_design"
                                                     :door-range="door.attr.door_range"
                                                     :hardware-suite="door.attr.suite"
            ></wb-designer-question-hardware-letterbox>

            <designer-question-hardware-letterbox-cowl :fabricator="fabricator"
                                                       v-model:target="door.attr.hardware_letterbox_cowl"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       :hardware-letterplate="door.attr.hardware_letterbox"
                                                       :hardware-colour="door.attr.hardware_colour"></designer-question-hardware-letterbox-cowl>

            <designer-question-hardware-letterbox-position :fabricator="fabricator"
                                                           v-model:target="door.attr.hardware_letterbox_pos"
                                                           :slab="door.attr.slab"
                                                           :side-panels="door.attr.side_panels"
                                                           :frame-id="door.attr.frame_style.frame_id"
                                                           :frame-material="door.attr.frame_material"
                                                           :hardware-letterbox="door.attr.hardware_letterbox"></designer-question-hardware-letterbox-position>
        </div>
        <div>
            <wb-designer-question-hardware-knocker :fabricator="fabricator"
                                                   v-model:target="door.attr.hardware_knocker"
                                                   :slab="door.attr.slab"
                                                   :hardware-handle="door.attr.hardware_handle"
                                                   :hardware-spyhole="door.attr.hardware_spy_hole"
                                                   :hardware-colour="door.attr.hardware_colour"
                                                   :door-range="door.attr.door_range"
                                                   :hardware-suite="door.attr.suite"
            ></wb-designer-question-hardware-knocker>

            <designer-question-hardware-knocker-position :fabricator="fabricator"
                                                         v-model:target="door.attr.hardware_knocker_pos"
                                                         :slab="door.attr.slab"
                                                         :frame-material="door.attr.frame_material"
                                                         :hardware-knocker="door.attr.hardware_knocker"></designer-question-hardware-knocker-position>
        </div>
        <div>
            <wb-designer-question-hardware-spy-hole :fabricator="fabricator"
                                                    v-model:target="door.attr.hardware_spy_hole"
                                                    :slab="door.attr.slab"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :glass-design="door.attr.glass_design"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :hardware-knocker="door.attr.hardware_knocker"
                                                    :hardware-colour="door.attr.hardware_colour"
                                                    :door-range="door.attr.door_range"
                                                    :hardware-suite="door.attr.suite"
            ></wb-designer-question-hardware-spy-hole>

            <designer-question-hardware-spy-hole-position :fabricator="fabricator"
                                                          v-model:target="door.attr.hardware_spy_hole_pos"
                                                          :slab="door.attr.slab"
                                                          :frame-material="door.attr.frame_material"
                                                          :hardware-spy-hole="door.attr.hardware_spy_hole"></designer-question-hardware-spy-hole-position>
        </div>
        <div>
            <wb-designer-question-hardware-hinge :fabricator="fabricator"
                                                 v-model:target="door.attr.hardware_hinge"
                                                 :slab="door.attr.slab"
                                                 :opening_direction="door.attr.opening_direction"
                                                 :secured-by-design="door.attr.secured_by_design"
                                                 :hardware-colour="door.attr.hardware_colour"
                                                 :hinge-side="door.attr.hinge_side"
                                                 :frame-material="door.attr.frame_material"
                                                 :door-range="door.attr.door_range"
                                                 :hardware-suite="door.attr.suite"
            ></wb-designer-question-hardware-hinge>

            <designer-question-hardware-hinge-bolts v-show="technical_should_show" :fabricator="fabricator"
                                                    v-model:target="door.attr.hardware_hinge_bolts"
                                                    :hardware-hinge="door.attr.hardware_hinge"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :hardware-colour="door.attr.hardware_colour"></designer-question-hardware-hinge-bolts>
        </div>

        <div v-show="!is_firedoorrange && !is_stablerange">
            <designer-question-hardware-security-chain :fabricator="fabricator"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       v-model:target="door.attr.hardware_security_chain"
                                                       :hardware-colour="door.attr.hardware_colour"
                                                       :door-range="door.attr.door_range"></designer-question-hardware-security-chain>
        </div>

        <div class="designeroption" v-show="!is_firedoorrange && !is_stablerange">
            <designer-question-hardware-numerals :fabricator="fabricator"
                                                 v-model:target="door.attr.numerals"
                                                 :slab="door.attr.slab"
                                                 :hardware-handle="door.attr.hardware_handle"
                                                 :hardware-colour="door.attr.hardware_colour"
                                                 title="Numerals"></designer-question-hardware-numerals>
        </div>

        <div v-show="technical_should_show">
            <designer-question-restrictor :fabricator="fabricator"
                                          v-model:target="door.attr.restrictor"></designer-question-restrictor>

            <designer-question-closer v-if="is_firedoorrange" :fabricator="fabricator"
                                      v-model:target="door.attr.closer"></designer-question-closer>

        </div>

        <div v-show="technical_should_show">
            <designer-question-technical-profile :fabricator="fabricator"
                                                 :frame-colour-internal="door.attr.frame_colour_internal"
                                                 :frame-colour-external="door.attr.frame_colour_external"
                                                 :frame-material="door.attr.frame_material"
                                                 :secured-by-design="door.attr.secured_by_design"
                                                 :hardware-handle="door.attr.hardware_handle"
                                                 :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                 :opening-direction="door.attr.opening_direction"
                                                 v-model:target="door.attr.profile"></designer-question-technical-profile>
        </div>

        <div v-show="technical_should_show">
            <wb-designer-question-addons :fabricator="fabricator"
                                         v-model:target="door.attr.addons"
                                         :frame-profile="door.attr.profile"
                                         :frame-colour-internal="door.attr.frame_colour_internal"
                                         :frame-colour-external="door.attr.frame_colour_external"
                                         :frame-combination="door.attr.frame_style.frame_id"></wb-designer-question-addons>
        </div>

        <div v-show="technical_should_show">
            <wb-designer-question-technical-threshold :fabricator="fabricator"
                                                      title="Choose Your Threshold"
                                                      v-model:target="door.attr.threshold"
                                                      :frame-colour-internal="door.attr.frame_colour_internal"
                                                      :frame-colour-external="door.attr.frame_colour_external"
                                                      :opening-direction="door.attr.opening_direction"
                                                      :frame-profile="door.attr.profile"
                                                      :door-range="door.attr.door_range"></wb-designer-question-technical-threshold>

        </div>

        <div class="designeroption" v-show="technical_should_show">
            <h3>Select Any Required Cills</h3>
            <designer-question-technical-cill v-if="!is_firedoorrange" :fabricator="fabricator"
                                              v-model:target="door.attr.cill"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :opening-direction="door.attr.opening_direction"
                                              :frame-profile="door.attr.profile"
                                              :frame-combination="door.attr.frame_style.frame_id"
                                              :component_id="'cill'"
            ></designer-question-technical-cill>

            <designer-question-technical-cill v-if="left_flag_sill && !is_firedoorrange" :fabricator="fabricator"
                                              v-model:target="door.attr.side_panels.left_flag_sill_id"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-profile="door.attr.profile"
                                              title="Left Sidepanel Flag"
                                              side-panel="left"
                                              :frame-combination="door.attr.frame_style.frame_id"
                                              :component_id="'left_flag_cill'"
            ></designer-question-technical-cill>

            <designer-question-technical-cill v-if="right_flag_sill && !is_firedoorrange" :fabricator="fabricator"
                                              v-model:target="door.attr.side_panels.right_flag_sill_id"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-profile="door.attr.profile"
                                              title="Right Sidepanel Flag"
                                              side-panel="right"
                                              :frame-combination="door.attr.frame_style.frame_id"
                                              :component_id="'right_flag_cill'"
            ></designer-question-technical-cill>
        </div>

        <div v-show="technical_should_show">
            <wb-designer-question-door-drip-colour v-show="technical_should_show && 1===2" :fabricator="fabricator"
                                                   title="Choose A Door Drip colour"
                                                   :external-colour="door.attr.external_colour"
                                                   v-model:target="door.attr.door_drip_colour"
                                                   :frame-profile="door.attr.profile"></wb-designer-question-door-drip-colour>

            <designer-question-technical-drainage :fabricator="fabricator"
                                                     v-model:target="door.attr.drainage"
                                                     :cill="door.attr.cill"
                                                     :threshold="door.attr.threshold"></designer-question-technical-drainage>
        </div>

        <div v-if="is_stablerange">
            <div class="designeroption" data-designer-component-id="meeting_bar_style">
                <h3>Meeting Rail Colour</h3>
                <div class="stylesoption">
                    <div class="row">
                        <div class="col-md">
                            <designer-question-meeting-rail-colour
                                :fabricator="fabricator"
                                title="Bottom Meeting Style (Outside)"
                                :door-colour="door.attr.external_colour"
                                v-model:target="door.attr.meeting_bar_outside"
                                :frame-profile="door.attr.profile"
                            ></designer-question-meeting-rail-colour>
                        </div>
                        <div class="col-md">
                            <designer-question-meeting-rail-colour
                                :fabricator="fabricator"
                                title="Top Meeting Style (Inside)"
                                :door-colour="door.attr.door_colour_internal"
                                v-model:target="door.attr.meeting_bar_inside"
                                :frame-profile="door.attr.profile"
                                :meeting-rail-outside="door.attr.meeting_bar_outside"
                            ></designer-question-meeting-rail-colour>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-show="technical_should_show">
            <shepley-designer-question-measurements title="Enter Your Required Measurements"
                                                    :fabricator="fabricator"
                                                    :slab="door.attr.slab"
                                                    :external-colour="door.attr.external_colour"
                                                    :internal-colour="door.attr.door_colour_internal"
                                                    :frame-profile="door.attr.profile"
                                                    :threshold="door.attr.threshold"
                                                    :frame-id="door.attr.frame_style.frame_id"
                                                    :side-panels="door.attr.side_panels"
                                                    :addons="door.attr.addons"
                                                    :cill="door.attr.cill"
                                                    :hardware-lock="door.attr.hardware_lock"
                                                    :hardware-hinge="door.attr.hardware_hinge"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :hardware-knocker="door.attr.hardware_knocker"
                                                    :hardware-spy-hole="door.attr.hardware_spy_hole"
                                                    :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                    :hardware-letterbox="door.attr.hardware_letterbox"
                                                    :hardware-letterbox-position="door.attr.hardware_letterbox_pos"
                                                    :hardware-rim-lock="door.attr.hardware_rim_lock"
                                                    :hardware-rim-lock-position="door.attr.hardware_rim_lock_pos"
                                                    :mdd="mdd"
                                                    :technical_should_show="technical_should_show"
                                                    v-model:target="door.attr.measurements"></shepley-designer-question-measurements>
        </div>

        <div class="designeroption" v-if="reference_on" data-designer-component-id="reference">
            <h3>Enter A Door Reference</h3>
            <div class="stylesoption">
                <div class="form-group">
                    <input dusk="door_reference" type="text" v-model="door.attr.reference" class="form-control">
                </div>
            </div>
        </div>
        <input v-else dusk="door_reference" type="hidden" v-model="door.attr.reference" class="form-control"
               value="Retail Door">

      <designer-question-notes v-model:target="door.attr.notes"></designer-question-notes>

      <designer-navigation
          v-if="show_navigation"
          :visible_designer_configurator_components="visible_designer_configurator_components"
          transition="designer-navigation"
      ></designer-navigation>

    </div>

</template>

<script type="text/ecmascript-6">
    import DoorConfigurator from "../DoorConfigurator.vue";

    export default {
        mixins: [
            DoorConfigurator
        ],
        props: {
        },
        computed: {
            is_firedoorrange() {
                return this.door_type === 'fire';
            },
            is_stablerange(){
                return this.door.attr.door_range === 63;
            },
        },
        methods: {
            defaults() {
                return {
                    25: {
                        "attr": {
                            "fabricator": 7,
                            "door_range": 25,
                            "hardware_suite": 18,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_design": 1,
                            "hardware_colour": 17,
                            "hardware_handle": 154,
                            "hardware_hinge": 370,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 1,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 813,
                            "hardware_cylinder": 759,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 7588,
                            "threshold": 7591,
                            "side_panels": {
                                "left": 1,
                                "right": 1,
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 2,
                            "notes": "",
                            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                            "suite": 18,
                            "hardware_rim_lock": 825,
                            "hardware_cylinder_stable": 759,
                            "hardware_rim_lock_pos": 10661
                        }
                    },
                    60: {
                        "attr": {
                            "fabricator": 7,
                            "door_range": 60,
                            "hardware_suite": 18,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_design": 1,
                            "hardware_colour": 17,
                            "hardware_handle": 154,
                            "hardware_hinge": 370,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 428,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 813,
                            "hardware_cylinder": 759,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 7588,
                            "threshold": 7591,
                            "side_panels": {
                                "left": 1,
                                "right": 1,
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 2,
                            "notes": "",
                            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                            "suite": 18,
                            "hardware_rim_lock": 825,
                            "hardware_rim_lock_pos": 10684,
                            "hardware_cylinder_stable": 759
                        }
                    },
                    61: {
                        "attr": {
                            "fabricator": 7,
                            "door_range": 61,
                            "hardware_suite": 18,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_design": 1,
                            "hardware_colour": 17,
                            "hardware_handle": 154,
                            "hardware_hinge": 370,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 443,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 813,
                            "hardware_cylinder": 759,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 7588,
                            "threshold": 7591,
                            "side_panels": {
                                "left": 1,
                                "right": 1,
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 2,
                            "notes": "",
                            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                            "suite": 18,
                            "hardware_rim_lock": 825,
                            "hardware_rim_lock_pos": 10699,
                            "hardware_cylinder_stable": 759
                        }
                    },
                    62: {
                        "attr": {
                            "fabricator": 7,
                            "door_range": 62,
                            "hardware_suite": 18,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_design": 277,
                            "hardware_colour": 17,
                            "hardware_handle": 154,
                            "hardware_hinge": 370,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 450,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 813,
                            "hardware_cylinder": 759,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 7588,
                            "threshold": 7591,
                            "side_panels": {
                                "left": 1,
                                "right": 1,
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 2,
                            "notes": "",
                            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                            "suite": 18,
                            "hardware_rim_lock": 825,
                            "hardware_rim_lock_pos": 10706,
                            "hardware_cylinder_stable": 759
                        }
                    },
                    63: {
                        "attr": {
                            "fabricator": 7,
                            "door_range": 63,
                            "hardware_suite": 18,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "hardware_colour": 17,
                            "hardware_handle": 1790,
                            "hardware_hinge": 1308,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 426,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 1286,
                            "hardware_cylinder": 759,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 7588,
                            "threshold": 7591,
                            "side_panels": {
                                "left": 1,
                                "right": 1,
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 2,
                            "notes": "",
                            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                            "meeting_bar_outside": 1,
                            "hardware_cylinder_stable": 759,
                            "meeting_bar_inside": 1
                        }
                    },
                    127: {
                        "attr": {
                            "fabricator": 7,
                            "door_range": 127,
                            "hardware_suite": 18,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_design": 1,
                            "hardware_colour": 17,
                            "hardware_handle": 154,
                            "hardware_hinge": 370,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 2159,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 813,
                            "hardware_cylinder": 759,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 7588,
                            "threshold": 7591,
                            "side_panels": {
                                "left": 1,
                                "right": 1,
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 2,
                            "notes": "",
                            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                            "suite": 18,
                            "hardware_rim_lock": 825,
                            "hardware_rim_lock_pos": 470351,
                            "hardware_cylinder_stable": 759
                        }
                    },
                }
            },
      }
    }
</script>
